var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name, _vm.maxHeight],style:(_vm.mainCssVars),attrs:{"id":`${_vm.cms.scroll_id}`}},[_c('grid',{class:['grid--container', `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[(_vm.content)?_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__content`],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 4, width: 19 },
        { size: 5, x: 4, width: 19 },
      ]}},[_c('a-copy',{class:`${_vm.name}__copy`,attrs:{"cms":_vm.cms}})],1):_vm._e()],1),_vm._v(" "),_vm._l((_vm.cms.battenberg),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",class:`${_vm.name}__battenberg`,attrs:{"cms":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }